import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ToastContainerWithClearAll } from '@rsos/components/capstone/base/Toast';
import { LayoutProvider, LayoutHeader, LayoutBody } from '../base/Layout';
import AdminLayout from './AdminLayout';
import { AppVersionMonitorToast } from './AppVersionMonitorToast';
import Navigation from './Navigation';
import SessionPortal from './SessionPortal';

const LayoutContent = ({ children, persistor, showSessionPortal = true }) => {
  let location = useLocation();
  const user = useSelector(state => state.sinatra.user);

  let { currentOrg = {}, currentRole = {}, isLoggedIn = false } = user;

  if (!currentOrg) {
    currentOrg = { name: '' };
  }

  if (!currentRole) {
    currentRole = {
      application: '',
    };
  }

  const [path, setPath] = useState(location?.pathname);
  const adminPaths = [
    '/admin/psap',
    '/admin/access',
    '/admin/integrations',
    '/admin/integrations/inbound',
    '/admin/integrations/outbound',
    '/admin/data-source',
    '/admin/share-and-chat',
    '/admin/settings',
    '/admin/alerts-routing',
    '/admin/responders',
    // This path no longer exists but we redirect to /admin/messaging when it is visited
    '/admin/text-from-911',
    '/admin/messaging',
    '/admin/notifications',
    '/admin/keywords',
    '/admin/landing-zones',
  ];
  const isAdminPathName = adminPaths.some(adminPath =>
    path.includes(adminPath),
  );

  // The SSO sign-in screen is a standalone public page that renders its own
  // branding, so the shared top navigation bar is hidden there.
  const hideNavigation = path === '/sso';

  useEffect(() => {
    if (location?.pathname) {
      setPath(location.pathname);
    }
  }, [location]);

  return (
    <LayoutProvider>
      {!hideNavigation && (
        <LayoutHeader>
          <Navigation path={path} persistor={persistor} />
        </LayoutHeader>
      )}
      <LayoutBody>
        <ToastContainerWithClearAll stacked />
        <AppVersionMonitorToast />
        {isAdminPathName ? <AdminLayout>{children}</AdminLayout> : children}
      </LayoutBody>
      {/* showSessionPortal is derived from the renderer app name in Layout.
          Login/auth pages pass false so transient persisted auth state cannot
          render the portal timeout warning outside the actual portal shell. */}
      {showSessionPortal && isLoggedIn && <SessionPortal />}
    </LayoutProvider>
  );
};

export default LayoutContent;
